import React, { Component } from 'react';
import { connect } from 'react-redux';
import { openModal } from '../../state/actions/modal';

/**
 * @class ModalRevealButton
 *
 * @description
 * Class for component to reveal the modal.
 *
 * @example
 * <ModalRevealButton />
 */
@connect(
	state => ({
		isModalClosed: state.modal.isModalClosed,
		translations: state.setup.translations,
		countryCode: state.user.profileData.countryCode
	}),
	dispatch => ({
		openModal: () => {
			dispatch(openModal());
		}
	})
)
export default class ModalRevealButton extends Component {

	/**
	 * @constructor
	 *
	 * @param {Object} props
	 */
	constructor (props) {
		super(props);
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		const { isModalClosed, translations, countryCode } = this.props;
		return (
			<div
				className={'modal__reveal'}
				data-active={isModalClosed}
				onClick={() => this.props.openModal()}>
				{translations.showQuestion[countryCode]} +
			</div>
		);
	}
}
